module.exports = __webpack_public_path__ + "static/scale-model-of-the-point-of-fox-point-in-providence-rhode-island-468ce5c228517be5495149484395bd9d.png";